module.exports = __webpack_public_path__ + "img/newLoginTop.4a73a690.png";